<template>
  <div @click.self="close" class="modal-background">
    <div class="modal">
      <div class="nav">
        <div v-if="closeNavButton" class="right-elem">
          <img @click="close" class="close" src="/img/icons/icon-close-black.svg">
        </div>
        <div v-if="backNavButton" class="left-elem">
          <img @click="back" class="close" src="/img/icons/icon-arrow-left-big.svg">
        </div>
      </div>
      <div class="modal-container">
        <div v-if="this.$slots.title" class="title">
          <slot name="title"></slot>
        </div>
        <div v-if="this.$slots.body" class="body">
          <slot name="body"></slot>
        </div>
      </div>
      <div v-if="closeButtonText" class="footer">
        <button @click="close">{{ closeButtonText }}</button>
        <button class="button-confirm" v-if="confirmButtonText" @click="confirm">{{ confirmButtonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "modal",
    props: {
      closeButtonText: String,
      confirmButtonText: String,
      backNavButton: Boolean,
      closeNavButton: Boolean
    },
    methods: {
      close() {
        this.$emit('close')
      },
      back() {
        this.$emit('back')
      },
      confirm() {
        this.$emit('confirm')
      }
    }
  };
</script>

<style scoped>

  .modal-background {
    @apply fixed inset-0 flex justify-center items-center bg-grey-transparent z-50 py-4;
  }

  .modal {
    @apply bg-white rounded-lg mx-6 max-h-full;
  }

  .modal-container {
    max-height: 80vh;
    @apply px-5 pt-10 pb-8 border-grey-border flex flex-col items-center overflow-y-auto;
  }

  .nav {
    @apply flex flex-row-reverse justify-between;
  }

  .left-elem {
    @apply p-4 text-center;
  }

  .right-elem {
    @apply p-4 text-center;
  }

  .title {
    @apply text-2xl text-black mb-6
  }

  .body {
    max-height: 80vh;
    @apply text-grey-text mx-auto flex flex-col items-center flex-wrap overflow-y-auto;
  }

  .footer {
    @apply py-3 flex justify-center text-secondary text-center;
  }

  .c {
    @apply w-full pt-6 pb-8 px-5 text-grey-text text-left border-b-1 border-grey-border;
  }

  button {
    @apply w-1/2 uppercase
  }

  .button-confirm {
    @apply font-bold
  }

</style>

